import {
  CREATELOSTFOUND,
  DELETELOSTFOUND,
  GETLOSTFOUND,
  GETLOSTFOUNDBYID,
  UPDATELOSTFOUND,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATELOSTFOUND:
      return { ...state, lostFoundSaveStatus: action.payload.success };
    case GETLOSTFOUND:
      return { ...state, lostFoundList: action.payload.data };
    case GETLOSTFOUNDBYID:
      return { ...state, lostFoundDetail: action.payload.data };
    case UPDATELOSTFOUND:
      return { ...state, lostFoundUpdateStatus: action.payload.success };
    case DELETELOSTFOUND:
      return { ...state, lostFoundDeleteStatus: action.payload.success };
    default:
      return state;
  }
}